import { getCookie } from '../shared/cookieHelper';

window.MailingAddressAutoComplete = function() {
    var addressInput = document.getElementById('shipping_address');
    var autocompleteOptions = {
        componentRestrictions: { country: "us" },
        fields: ["address_components"],
    };

    const autocomplete = new google.maps.places.Autocomplete(addressInput, autocompleteOptions);
    autocomplete.addListener("place_changed", () => {
        var place = autocomplete.getPlace();
        if (place.address_components) {
            $('[address-component="line1"]').val(place.address_components.find(c => c.types.includes("street_number"))["short_name"] + " " + place.address_components.find(c => c.types.includes("route"))["long_name"]);
            $('[address-component="city"]').val(place.address_components.find(c => c.types.includes("locality"))["long_name"]);
            $('[address-component="state"]').val(place.address_components.find(c => c.types.includes("administrative_area_level_1"))["short_name"]);
            $('[address-component="zip"]').val(place.address_components.find(c => c.types.includes("postal_code"))["short_name"]);

            $('#shipping_address_form').removeClass('d-none');
            $('#update_address').addClass('d-none');
        }
        else {
            window.alert("No details available for input: '" + place.name + "'");
            return;
        }
    });
}

$(function () {
    if ($('#locknlist_purchase_information_page').length) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAiTYeI5JpL0iYv5WskHudfIQwHKvZVK6E&libraries=places&callback=MailingAddressAutoComplete';
        script.async = true;
        document.body.appendChild(script);

        var $loading = $('#ll_loading-div').hide();
        $(":input").inputmask();
        $("#phone").inputmask("(999) 999-9999", { clearIncomplete: true });
        $("#aphone").inputmask("(999) 999-9999", { clearIncomplete: true });

        $('#firstname').on('input', function () {
            validateandTrim(this);
        });
        $('#lastname').on('input', function () {
            validateandTrim(this);
        });

        $('#afirstname').on('input', function () {
            validateandTrim(this);
        });
        $('#alastname').on('input', function () {
            validateandTrim(this);
        });

        $('#link-mls').on('input', function () {
            validateandTrim(this);
        });

        $('#email').on('input', function () {
            validateEmail(this);
        });
        $('#aemail').on('input', function () {
            validateAgentEmail(this);
        });
        function validateandTrim(input) {
            var a = input.value;
            if (a.trim().length <= 0) {
                $(input).val(a.trim());
            }
        };
        function validateEmail(input) {
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            const errorMessage = document.getElementById('email-error-message');
            if (!emailPattern.test(input.value)) {
                errorMessage.textContent = 'Invalid email format';
            }
            else {
                errorMessage.textContent = '';
            }
        };
        function validateAgentEmail(input) {
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            const errorMessage = document.getElementById('a-error-message');
            if (!emailPattern.test(input.value)) {
                errorMessage.textContent = 'Invalid email format';
            }
            else {
                errorMessage.textContent = '';
            }
        };
        $('#listingstatus').on('change', function (e) {
            var optionSelected = $("option:selected", this);
            if (this.value != "Listed") {
                alert("We’re sorry, your home must already be listed to purchase a lock.");
                return false;
            }
        });

        $('#btnSavePurchaseInfo').on('click', function (e) {
            e.preventDefault();

            if ($('#purchase-form').valid()) {
                var lockLater = $(this).data('locklater');

                if (!lockLater) {
                    if ($("#listingstatus option:selected").text() != "Listed") {
                        document.getElementById("listingstatus").setCustomValidity("We’re sorry, your home must already be listed to purchase a lock.");
                        alert("We’re sorry, your home must already be listed to purchase a lock.");
                        return false;
                    }
                }
                var form = new FormData();
                form.append("firstname", document.getElementById('firstname').value);
                form.append("lastname", document.getElementById('lastname').value);
                form.append("phone", document.getElementById('phone').value);
                form.append("email", document.getElementById('email').value);

                var line1 = $('[address-component="line1"]').val();
                var line2 = $('[address-component="line2"]').val();
                var city = $('[address-component="city"]').val();
                var state = $('[address-component="state"]').val();
                var zip = $('[address-component="zip"]').val();

                if (!line1 || !city || !state || !zip) {
                    $('#error_message').removeClass('d-none');
                    return false;
                }

                form.append("line1", line1);
                form.append("line2", line2);
                form.append("city", city);
                form.append("state", state);
                form.append("zip", zip);

                form.append("afirstname", document.getElementById('afirstname').value);
                form.append("alastname", document.getElementById('alastname').value);
                form.append("aphone", document.getElementById('aphone').value);
                form.append("aemail", document.getElementById('aemail').value);

                if (!lockLater) {
                    form.append("listing-status", $("#listingstatus option:selected").text());
                }
                form.append("link-mls", document.getElementById('link-mls').value)

                var loc1 = $("#prefixurl").val();//getCookie("ll_prefix_url");

                $.ajax({
                    url: loc1 + '/purchase-lock',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    beforeSend: function () {
                        $loading.show();
                    },
                    success: function (response) {
                        $loading.hide();
                        window.location.href = loc1 + '/e-sign?lockLater=' + lockLater
                    }
                });
            }
            else {
                return false;
            }
        });

        $('#update_address').on('click', function () {
            $('#shipping_address_form').removeClass('d-none');
            $('#update_address').addClass('d-none');
        });

        $('[address-component]').on('keyup change', function () {
            var $this = $(this);

            if ($this.not('[address-component="line2"]') && !$this.val()) {
                $this.addClass('blank-error');
                $('#shipping_address').val('');
            }
            else {
                $this.removeClass('blank-error');

                var line1 = $('[address-component="line1"]').val();
                var line2 = $('[address-component="line2"]').val();
                var city = $('[address-component="city"]').val();
                var state = $('[address-component="state"]').val();
                var zip = $('[address-component="zip"]').val();

                var address = !line1 || !city || !state || !zip ? "" : `${line1}${line2 ? " " + line2 : ""}, ${city}, ${state} ${zip}`;
                $('#shipping_address').val(address);
            }
        });

        $('#shipping_address').bind("cut copy paste", function (e) {
            e.preventDefault();
        });
    }
});